import { render } from "./SatDmMonitoringIcon.vue?vue&type=template&id=6b0c3ba4&scoped=true"
import script from "./SatDmMonitoringIcon.vue?vue&type=script&lang=js"
export * from "./SatDmMonitoringIcon.vue?vue&type=script&lang=js"

import "./SatDmMonitoringIcon.vue?vue&type=style&index=0&id=6b0c3ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0c3ba4"]])

export default __exports__